<script context="module">
  import PageHead from "./../Components/PageHead.svelte";
  import AdditionalHelp from "./../Components/AdditionalHelp.svelte";
  import Breadcrumb from "./Partials/Breadcrumb.svelte";
  import Alerts from "../Shared/Alerts.svelte";
  export { default as layout } from "../Shared/Layout.svelte";
</script>

<script>
  import { inertia, useForm } from "@inertiajs/svelte";
  import { formatGeneral } from "cleave-zen";
  import ReceiptFaq from "../FAQ/ReceiptFaq.svelte";

  const form = useForm("receiptSearchForm", {
    vin: null,
    plate_number: null,
    zip: null,
  });

  function handleSubmit() {
    $form.clearErrors();
    $form.post(route("receipt.lookup"));
  }

  function inputVIN(e) {
    $form.vin = formatGeneral(e.target.value, {
      blocks: [4],
      numericOnly: true,
    });
  }
</script>

<PageHead>
  <svelte:fragment slot="title">Find Receipt</svelte:fragment>
  <svelte:fragment slot="tagline">
    To find your receipt, first search for your vehicle.
  </svelte:fragment>
  <Breadcrumb slot="breadcrumb">
    <span slot="home"></span>
    <span slot="receipt"></span>
  </Breadcrumb>
</PageHead>

<div class="row">
  <div class="col-md-8">
    <div class="card">
      <div
        class="card-body row align-items-center justify-content-center text-center"
      >
        <div class="col-md-8">
          <Alerts />
          <div class="form-floating">
            <input
              class:is-invalid={$form.errors.vin}
              class="form-control"
              placeholder="0000-0000-0000"
              id="vinId"
              minlength="4"
              name="vin"
              bind:value={$form.vin}
              on:input={inputVIN}
            />
            <label for="renewalId"
              >Last 4 digits of Vehicle ID Number (VIN)</label
            >
            {#if $form.errors.vin}
              <div class="invalid-feedback">
                {$form.errors.vin}
              </div>
            {/if}
          </div>
          <div class="form-floating mt-2">
            <input
              class:is-invalid={$form.errors.plate_number}
              class="form-control input-license-plate"
              maxlength="7"
              placeholder="000-000"
              id="licensePlateNumber"
              name="plate_number"
              bind:value={$form.plate_number}
            />
            <label for="licensePlateNumber">License Plate Number</label>
            {#if $form.errors.plate_number}
              <div class="invalid-feedback">
                {$form.errors.plate_number}
              </div>
            {/if}
          </div>
          <div class="form-floating mt-2">
            <input
              class:is-invalid={$form.errors.zip}
              class="form-control input-zip"
              maxlength="5"
              minlength="5"
              placeholder="00000"
              id="zipCode"
              name="zip"
              bind:value={$form.zip}
            />
            <label for="zipCode">Zip Code</label>
            {#if $form.errors.zip}
              <div class="invalid-feedback">
                {$form.errors.zip}
              </div>
            {/if}
          </div>
        </div>

        <div class="text-center mt-2">
          <button
            class="btn btn-outline-secondary"
            use:inertia={{
              href: window.route("home"),
              preserveState: true,
            }}
            id="button-addon2">Cancel</button
          >
          <button
            class="btn btn-success"
            type="submit"
            on:click|preventDefault={handleSubmit}
            disabled={$form.processing}>Submit</button
          >
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-4 mt-4 mt-md-0">
    <ReceiptFaq />
    <AdditionalHelp />
  </div>
</div>
